export const flagSdkOptions: { [key: string]: string } = {
  anyClient: 'All client-side SDKs',
  client: 'SDKs using Client-side ID',
  mobile: 'SDKs using Mobile key',
  server: 'No client-side SDKs',
};
